import { Icon } from "armstrong-react";
import React from "react";
import HtmlSerialiser from "slate-html-serializer";
import { IToolbarProps } from ".";
import { DropdownButton } from "../../../../core/atoms/atoms";
import SnippetPicker from "../../../../core/molecules/snippetPicker";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import {
  BlockSerialiserRule,
  InlineSerialiserRule,
  MarkSerialiserRule,
} from "../html";
import * as SlateUtils from "../slateUtils";

export const ToggleSnippetsButton = ({ editorRef }: IToolbarProps) => {
  const [open, setOpen] = React.useState<boolean>(false);

  const onButtonClick = () => {
    GoogleAnalyticsHelper.logEvent("Message snippets", "Click", "Open menu");
    setOpen(!open);
    editorRef.focus();
  };

  const insertSnippet = (snippetContent: string): void => {
    const serializer = new HtmlSerialiser({
      rules: [BlockSerialiserRule, InlineSerialiserRule, MarkSerialiserRule]
    });

    const { document } = serializer.deserialize(snippetContent);

    // * selecting all text by mouse drag and deleting unsets the selection
    // * error with slate.js you cannot insert into a null path - https://github.com/ianstormtaylor/slate/issues/2942
    if (editorRef.value.selection.isUnset) {
      const { key } = editorRef.value.document.getFirstText();
      const range = SlateUtils.generateRange(key);

      // * Weird hackery to get content to insert into editor at start of document
      (editorRef as any)
        .focus()
        .setEnd(range.point)
        .insertFragmentAtRange(range.range, document);
    } else {
      editorRef.focus().insertFragment(document);
    }
    setOpen(false);

    GoogleAnalyticsHelper.logEvent(
      "Message snippets",
      "Click",
      "Insert snippet",
    );
  };

  return (
    <div className="slate-toolbar-dropdown">
      <DropdownButton
        buttonClassName="slate-toolbar-button"
        icomoon={Icon.Icomoon.power}
        label="Snippets"
        onClick={onButtonClick}
        excludeClickOutside={["snippet-picker__preview"]}
        renderDropdown={closeDropdown => (
          <SnippetPicker
            insertSnippet={insertSnippet}
            onInsert={closeDropdown}
          />
        )}
      />
    </div>
  );
};
